import { c as t } from "../../../index-34b1f277.js";
const { defineMultiStyleConfig: e, definePartsStyle: o } = t([
  "emptyStateContainer",
  "emptyStateText",
  "dropdownContent"
]), n = o({
  dropdownContent: {
    marginTop: 1,
    maxWidth: "100%"
  },
  emptyStateContainer: {
    maxWidth: "100%",
    _hover: {
      backgroundColor: "transparent",
      border: "unset",
      pointerEvents: "none"
    },
    _focus: {
      backgroundColor: "transparent",
      cursor: "auto",
      border: "unset",
      pointerEvents: "none"
    },
    _active: {
      backgroundColor: "transparent",
      cursor: "auto",
      border: "unset",
      pointerEvents: "none"
    }
  },
  emptyStateText: {
    color: "primary.300",
    _hover: { border: "unset" }
  },
  action: {
    minWidth: "100%"
  }
}), a = e({
  baseStyle: n
});
export {
  a as AutocompleteTheme
};
//# sourceMappingURL=Autocomplete.es.js.map
